import { useEffect } from 'react';
import { getParamFromUrl, isEntryFlow } from '../../utilities/urlResolver';

const useHandleBgBehavior = () => {
  useEffect(() => {
    const getBackgroundImage = () => {
      const randomNumber = Math.floor(Math.random() * 10) + 1;
      let type = 'city';
      const destinationIds = getParamFromUrl('destinations') || getParamFromUrl('pr_destinations');
      let destinationId = null;
      if (destinationIds) {
        if (destinationIds.length) {
          destinationId = destinationIds[0];
        } else {
          destinationId = destinationIds;
        }
      }

      if (window.holidayFinder.beachDestinationIds?.includes(parseInt(destinationId))) {
        type = 'beach';
      }

      if (isEntryFlow('link-presets-welcome') && getParamFromUrl('pr_backgroundImg')) {
        const hpBgImg = `https://image.content.travelyo-cdn.site/custom/holidayfinder/hp/hero/${getParamFromUrl('pr_backgroundImg')}`;
        document.querySelector(".hh-homepage-img").style.backgroundImage=`url('${hpBgImg}')`;
      }

      return `https://d16tr0byigrcd.cloudfront.net/hf/images/welcome-screen/desktop${window.holidayFinder.market === 4 ? '/HE' : ''}/default_${type}_${randomNumber}@2x.webp`
    }

    const wizardModalImgElement = document.querySelector('.hh-wizard-modal-img');

    if (wizardModalImgElement) {
      wizardModalImgElement.style.backgroundImage = `url(${getBackgroundImage()})`;
    }

    window.handleShowModal = () => {
      const homeImg = document.querySelector(".hh-homepage-img");
      const wizardImg = document.querySelector(".hh-wizard-modal-img");

      if (homeImg && wizardImg) {
        homeImg.classList.add("animate-exit");
        homeImg.classList.remove("animate-enter");
        wizardImg.classList.add("animate-enter");
        wizardImg.classList.remove("animate-exit");
      }
    }

    window.handleShowHome = () => {
      const homeImg = document.querySelector(".hh-homepage-img");
      const wizardImg = document.querySelector(".hh-wizard-modal-img");

      if (homeImg && wizardImg) {
        homeImg.classList.add("animate-enter");
        homeImg.classList.remove("animate-exit");
        wizardImg.classList.add("animate-exit");
        wizardImg.classList.remove("animate-enter");
      }
    }
  }, [])
}

export default useHandleBgBehavior;
